<template>
    <div class="slider">
      <div class="mask">
        <div class="container">
          <div class="title">
            <div class="text">
              <span>请完成下列验证后继续</span>
            </div>
            <div class="button-group">
              <van-icon class="icon-a------13-tubiao---Icon" name="replay" @click="reset"/>
              <van-icon class="icon-a-closeguanbi-xian" name="close" @click="close"/>
<!--              <span class="icon font_family icon-a&#45;&#45;&#45;&#45;&#45;&#45;13-tubiao-&#45;&#45;Icon" @click="reset"></span>-->
<!--              <span class="icon font_family icon-a-closeguanbi-xian" @click="close"></span>-->
            </div>
          </div>
          <div class="img">
            <div class="backgroup-img">
              <img
                ref="innerBgImg"
                class="inner-bg-img"
                :src="backgroupImg"
              />
            </div>
            <div
              class="move-img"
              :style="{left: `${moveX}px`}"
            >
              <img
                ref="innerMvImg"
                class="inner-mv-img"
                :src="moveImg"
              />
            </div>
          </div>
          <div class="slide" >
            <div
              class="slider-mask"
              :style="{width: `${blcokLeft}px`}"
            >
              <div
                class="block"
                ref="block"
                @mousedown="start"
                @touchstart="startTouch"
                @touchmove="moveTouch"
                @touchend="endTouch"
                :style="{left: `${blcokLeft}px`}"
              >
                <span class="yidun_slider_icon"></span>
              </div>
            </div>
          </div>
          <div
            class="loading"
            v-if="loading"
          >
            <span>loading...</span>
          </div>
        </div>
      </div>
    </div>
  </template>

<script>
import { parseDate2Str } from '@/views/util'

export default {
  name: 'Slider',
  props: {
    // 是否开启日志， 默认true
    log: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      innerBgImg: null,
      innerMvImg: null,
      startSlidingTime: '',
      trackArr: [],

      /**滑块背景图片 */
      backgroupImg: "",
      /**滑块图片 */
      moveImg: "",
      /**是否已经移动滑块 */
      startMove: false,
      /**滑块移动距离 */
      blcokLeft: 0,
      /**开始滑动的x轴 */
      startX: 0,
      /**划过的百分比 */
      movePercent: "",
      /**验证码唯一ID */
      uuid: "",
      /**滑块移动的x轴 */
      moveX: "",
      /** 加载遮罩标识 */
      loading: "",
      mobile: true
    }
  },
  mounted() {
    this.isMobile()
    this.getImg();
  },
  beforeDestroy() {
    document.removeEventListener("mousemove", this.move);
    document.removeEventListener("mouseup", this.up);
  },
  methods: {
    /**
     * 打印日志
     */
    printLog(msg, ...optionalParams) {
      if (this.log) {
        if (optionalParams && optionalParams.length > 0) {
          console.info(
              `滑块验证码[${msg}]`,
              optionalParams.length === 1 ? optionalParams[0] : optionalParams
          );
        } else {
          console.info(`滑块验证码[${msg}]`);
        }
      }
    },

    /**
     * 获取滑块图片
     */
    getImg() {
      this.loading = true;
      this.$emit("getImg", (data) => {
        this.printLog("getImg", data);
        this.loading = false;
        if (!data) return;
        this.backgroupImg = data.captcha.backgroundImage;
        this.moveImg = data.captcha.sliderImage;
        this.uuid = data.id;
        this.startSlidingTime = new Date();
      });
    },

    /**
     * 校验图片
     */
    validImg() {
      this.printLog(`滑块抬起`, this.movePercent);
      let dataObj = {
        bgImageWidth: this.$refs.innerBgImg?.clientWidth, //图像宽度
        bgImageHeight: this.$refs.innerBgImg?.clientHeight, //图像高度
        sliderImageWidth: this.$refs.innerMvImg?.clientWidth, //滑块宽度
        sliderImageHeight: this.$refs.innerMvImg?.clientHeight, //滑块高度
        startSlidingTime: parseDate2Str(this.startSlidingTime), //开始滑动时间
        entSlidingTime: parseDate2Str(new Date()), //结束滑动时间
        trackList: this.trackArr
      };

      this.trackArr = []; //重置滑动数据

      this.$emit("validImg", dataObj, this.uuid, (data) => {
        this.printLog("validImg", data);
        if (data === false) {
          this.reset();
        }
      });
    },

    /**
     * 重新生成图片
     */
    reset() {
      this.getImg();
      this.moveX = 0;
      this.movePercent = 0;
      this.startX = 0;
      this.blcokLeft = 0;
    },

    /**
     * 按钮关闭事件
     */
    close() {
      this.printLog("关闭按钮触发");
      this.$emit("close");
    },

    /**
     * 开始滑动
     */
    start(e) {
      this.startX = e.pageX;
      this.startMove = true;
        document.addEventListener("mousemove", this.move);
        document.addEventListener("mouseup", this.up);
    },
    /**
     * 移动端滑动
     */

    startTouch(e) {
      this.startX = e.changedTouches[0].screenX + 10;
      this.startMove = true;
    },

    moveTouch(e) {
      if (!this.startMove) return;
      const constmoveX = e.changedTouches[0].screenX - this.startX;
      const constmovePercent = this.moveX / 280;

      if (constmoveX <= 0) {
        this.blcokLeft = 0;
        this.moveX = 0;
        this.movePercent = 0;
      } else if (constmoveX >= 0 && constmoveX <= 235) {
        this.blcokLeft = constmoveX;
        this.moveX = constmoveX;
        this.movePercent = constmovePercent;
      } else if (constmoveX >= 235) {
        this.blcokLeft = 235;
        this.moveX = 235;
        this.movePercent = constmovePercent;
      }

      let obj = {
        x: this.moveX,
        y: 0,
        type: "move",
        t: (new Date().getTime() - this.startSlidingTime.getTime())
      };

      this.trackArr.push(obj);
    },

    endTouch(e) {
      if (!this.startMove) return;
      this.startMove = false;
      let obj = {
        x: this.moveX,
        y: 0,
        type: "up",
        t: (new Date().getTime() - this.startSlidingTime.getTime())
      };

      this.trackArr.push(obj);
      this.validImg();
    },

    /**
     * 滑块滑动事件
     */
    move(e) {
      if (!this.startMove) return;
      const constmoveX = e.pageX - this.startX;
      const constmovePercent = this.moveX / 280;

      if (constmoveX <= 0) {
        this.blcokLeft = 0;
        this.moveX = 0;
        this.movePercent = 0;
      } else if (constmoveX >= 0 && constmoveX <= 235) {
        this.blcokLeft = constmoveX;
        this.moveX = constmoveX;
        this.movePercent = constmovePercent;
      } else if (constmoveX >= 235) {
        this.blcokLeft = 235;
        this.moveX = 235;
        this.movePercent = constmovePercent;
      }

      let obj = {
        x: this.moveX,
        y: 0,
        type: "move",
        t: (new Date().getTime() - this.startSlidingTime.getTime())
      };

      this.trackArr.push(obj);
    },

    /**
     * 滑块鼠标抬起事件
     */
    up(e) {
      document.removeEventListener("mousemove", this.move);
      document.removeEventListener("mouseup", this.up);
      if (!this.startMove) return;
      this.startMove = false;

      let obj = {
        x: this.moveX,
        y: 0,
        type: "up",
        t: (new Date().getTime() - this.startSlidingTime.getTime())
      };

      this.trackArr.push(obj);
      this.validImg();
    },
    isMobile() {
      const flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      if(flag === null) {
        this.mobile = true;
      }else {
        this.mobile = false;
      }
    }
  }
}
</script>

  <style lang="less" scoped>
  .slider-mask {
    position: absolute;
    left: 0;
    top: 0;
    height: 40px;
    border: 0 solid #1991fa;
    background: #d1e9fe;
    border-radius: 2px;
  }
  .yidun_slider_icon {
    position: absolute;
    top: 50%;
    margin-top: -6px;
    left: 50%;
    margin-left: -6px;
    width: 14px;
    height: 10px;
    background-image: url(https://cstaticdun.126.net//2.13.7/images/icon_light.4353d81.png);
    background-position: 0 -13px;
    background-size: 32px 544px;
  }
  .inner-mv-img,
  .inner-bg-img,
  .title {
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    -khtml-user-select: none;
    user-select: none;
  }
  .slider {
    .mask {
      display: block;
      z-index: 998;
      background: rgba(0, 0, 0, 0);
      width: 310px;
      height: 280px;
    }
    .container {
      position: absolute;
      z-index: 999;
      width: 310px;
      height: 280px;
      margin: auto;
      background: rgba(255, 255, 255, 1);
      border-radius: 6px;
      box-shadow: 0px 0px 11px 0px rgba(153, 153, 153, 1);
      box-sizing: border-box;
      padding: 17px 15px;
      .title {
        font-size: 14px;
        color: #333;
        display: flex;
        justify-content: space-between;
        .button-group {
          display:flex;
          height:30px;
          width:45px;
          justify-content: space-between;
          span{
            font-size:17px;
            cursor: pointer;
          }
          .icon-a------13-tubiao---Icon{
            font-size:17px;
            color:#005cff
          }
          .icon-a-closeguanbi-xian{
            font-size:17px;
            color: #b1adbd;
          }
        }
      }
      .img {
        width: 280px;
        height: 180px;
        position: relative;
        img {
          width: 100%;
        }
        .backgroup-img {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
        }
        .move-img {
          width: 52.20338981px;
          position: absolute;
          left: 0;
          top: 0;
        }
      }
      .slide {
        width: 100%;
        height: 40px;
        border: 1px solid #e4e7eb;
        background-color: #f7f9fa;
        box-sizing: border-box;
        position: relative;
        &::before {
          position: absolute;
          content: "按住左边按钮移动完成上方拼图";
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 12px;
          color: #999;
          width: 100%;
          height: 100%;
          text-indent: 50px;
        }
        .block {
          width: 40px;
          height: 38px;
          background-color: #fff;
          box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
          display: flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          left: 0;
          top: 0;
          cursor: pointer;
          background-size: 30px;
          background-repeat: no-repeat;
          background-position: center;
        }
      }
      .block:hover {
        background-color: #1991fa;
      }
      .block:hover .yidun_slider_icon {
        background-image: url(https://cstaticdun.126.net//2.13.7/images/icon_light.4353d81.png);
        background-position: 0 0;
        background-size: 32px 544px;
      }
      .loading {
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.3);
        position: absolute;
        top: 0;
        left: 0;
        border-radius: 6px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
      }
    }
  }
  </style>
